import React, { FC } from 'react'
import styles from 'styles/components/header.module.scss'

type Props = {
  handleMenuToggle: () => void
}

const HeaderMenuButton: FC<Props> = React.memo((props) => {
  const { handleMenuToggle } = props
  return (
    <button className={styles.header__menu__button} onClick={handleMenuToggle} data-cy={'header-menu-button'}>
      <img src={'/icon/menu/menu.svg'} alt={'メニューの開閉'} />
    </button>
  )
})

export default HeaderMenuButton
